import { render, staticRenderFns } from "./BranchBalanceReport.vue?vue&type=template&id=3c67eea3&scoped=true"
import script from "./BranchBalanceReport.vue?vue&type=script&lang=js"
export * from "./BranchBalanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67eea3",
  null
  
)

export default component.exports